export default __webpack_public_path__ + "static/media/list-view.c4f5f709.svg";